import React from 'react'
import classnames from 'classnames'
import { AppBar, IconButton, Toolbar, Tooltip, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import MenuIcon from '@mui/icons-material/Menu'

import CorporationIcon from 'components/atoms/corporationIcon'
import ExternalLink from 'components/atoms/externalLink'

import { ENV_BANNER_ENABLED, HELP_URL } from 'qap/constants'
import QAPVars from 'qap/vars'

import CurrentUserMenu from './currentUserMenu'

type Props = {
  classes: any;
  onDrawerToggle: () => void;
  openSidebar: boolean;
};

const noPrint = {
  '@media print': {
    display: 'none'
  }
} as const

const styles = (theme: any) => ({
  root: {
    top: ENV_BANNER_ENABLED ? QAPVars.envBannerHeight : 0,
    '@media print': {
      position: 'static',
      boxShadow: 'none'
    }
  },

  corporationIcon: {
    height: '3.4em',
    width: 200,
    '@media print': {
      paddingLeft: 0,
      marginLeft: '-44px'
    },
  },

  flex: {
    flex: 1
  },

  navIcon: {
    ...noPrint
  },

  navIconHide: {
    [theme.breakpoints.up('lg')]: {
      display: 'none'
    }
  },

  helpLink: {
    marginRight: theme.spacing(6),
    textDecoration: 'none',
    ...noPrint
  },

  notificationContainer: {
    marginRight: theme.spacing(3)
  },

  appBarShiftOpen: {
    [theme.breakpoints.up('lg')]: {
      marginLeft: QAPVars.sideNavBarWidth,
      width: `calc(100% - ${QAPVars.sideNavBarWidth})`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    }
  },

  appBarShiftClose: {
    [theme.breakpoints.up('lg')]: {
      marginLeft: QAPVars.sideNavBarWidth,
      width: '100%',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  },

  toolbar: {
    paddingLeft: theme.spacing(1)
  },
})

const NavigationBar = ({
  classes,
  openSidebar,
  onDrawerToggle,
}: Props) => {
  const currentUserMenuRef = React.createRef()

  return (
    <AppBar className={classnames(classes.root, { [classes.appBarShiftOpen]: openSidebar, [classes.appBarShiftClose]: !openSidebar })}>
      <Toolbar className={classes.toolbar}>
        <Tooltip title={openSidebar ? '' : 'Expand the sidebar'}>
          <span onClick={onDrawerToggle}>
            <IconButton
              className={classnames(classes.navIcon, { [classes.navIconHide]: openSidebar })}
              size="large">
              <MenuIcon />
            </IconButton>
          </span>
        </Tooltip>
        <div className={classes.flex}>
          <CorporationIcon className={classes.corporationIcon} showFooterInPrint={true} />
        </div>

{ /* @ts-expect-error - TS2322 - Type '{ children: Element; to: string; className: any; }' is not assignable to type 'IntrinsicAttributes & Omit<Props & RefAttributes<unknown>, "classes"> & StyledComponentProps<"root" | "hideUnderline"> & object'. */}
        <ExternalLink to={HELP_URL} className={classes.helpLink}>
          <Typography variant='subtitle1'>Need help?</Typography>
        </ExternalLink>

        <CurrentUserMenu menuRef={currentUserMenuRef} />
      </Toolbar>
    </AppBar>
  )
}

export default withStyles(styles)(NavigationBar)
